import React from "react";
import Car from "./Car";

export default function App() {
  return <Car />;
}